export enum ERROR_TYPE {
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  WEBSOCKET_ERROR = 'WEBSOCKET_ERROR',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  UNKNOW_ERROR = 'UNKNOW_ERROR',
}

export class ImmersiveError extends Error {
  name: ERROR_TYPE;
  message: string;
  cause?: any;

  constructor({ name, message, cause }: { name: ERROR_TYPE; message: string; cause?: any }) {
    super();
    this.name = name;
    this.message = message;
    this.cause = cause;
  }
}
